@if (loading$ | async) {
  <gbc-loading-spinner class="spinner"></gbc-loading-spinner>
}
@if ((loading$ | async) === false) {
  <ng-content></ng-content>
}
